// create the epics without using async loading at this stage
import { combineEpics } from "redux-observable";
import { BehaviorSubject, mergeMap } from "rxjs";
import passwordMgmtEpics from "../../pages/AdminConsole/PasswordManagement/module/epic";
import reportParameterSectionEpics from "../../pages/AdminConsole/ReportManagement/ParameterSection/module/epic";
import reportReportSectionEpics from "../../pages/AdminConsole/ReportManagement/ReportSection/module/epic";
import templateMailManagementEpic from "../../pages/AdminConsole/TemplateMailManagement/module/epic";
import workflowManagementEpic from "../../pages/AdminConsole/WorkflowManagement/module/epic";
import approvalEpics from "../../pages/ApprovalsManagement/module/epic";
import brManagementEpic from "../../pages/BusinessRolesManagement/module/epic";
import catalogEpics from "../../pages/CatalogManagement/module/epic";
import CertificationReferenceEpic from "../../pages/CertificationReference/module/epic";
import changePasswordEpic from "../../pages/ChangePassword/module/epic";
import createCertificationEpic from "../../pages/CreateCertifaction/module/epic";
import delegationsEpics from "../../pages/DelegationManagement/module/epic";
import emergencyUserEpic from "../../pages/EmergencyUsers/module/epics";
import entitlementRefereceEpic from "../../pages/EntitlementReference/module/epic";
import externalPortalEpics from "../../pages/ExternalPortal/module/epic";
import LoginEpic from "../../pages/Login/module/epic";
import manualReferenceEpic from "../../pages/ManualsReference/module/epic";
import ProfileManagementEpic from "../../pages/ProfileManagement/module/epic";
import ReportRequestEpic from "../../pages/Report/module/epic";
import resetPasswordEpic from "../../pages/ResetPassword/module/epic";
import ServiceRequestEpic from "../../pages/ServiceRequest/module/epic";
import taskEpics from "../../pages/TaskManagement/module/epic";
import usersRefereceEpic from "../../pages/UsersReference/module/epic";
import welcomeEpics from "../../pages/Welcome/module/epic";
import abilitationEpics from "./../../pages/AbilitationManagement/module/epic";
import historyRequestEpics from "./../../pages/HistoryRequest/module/epic";
import temporaryAbilitationsEpics from "./../../pages/TemporaryAbilitations/module/epic";
import userEntitlementsEpic from "../../pages/UserEntitlements/module/epic";
import twoFactorAuthEpics from "../../common/TwoFactorAuth/module/epic";
import technicalUsersEpic from "../../pages/TechnicalUser/module/epic";

// CONSOLE ADMIN
import tablesConfigurationEpic from "../../common/TablesConfiguration/tcEpics";
import consoleAdminApplicationEntitlementEpic from "../../pages/AdminConsole/ApplicationsAbilitationsManagement/module/epic";
import auditManagementEpic from "../../pages/AdminConsole/AuditManagement/module/epic";
import consoleAdminBRManagementEpic from "../../pages/AdminConsole/BRManagement/module/epic";
import consoleAdminCatalogMgmtEpic from "../../pages/AdminConsole/CatalogManagement/module/epic";
import consoleAdminCertificationConfigurationsEpic from "../../pages/AdminConsole/CertificationConfigurationsManagement/module/epic";
import externalPortalManagementEpic from "../../pages/AdminConsole/ExternalPortalManagement/module/epic";
import manualsManagementEpic from "../../pages/AdminConsole/ManualsManagement/module/epic";
import notifyManagementEpic from "../../pages/AdminConsole/NotifyAdminManagement/module/epic";
import profilesMgmtEpic from "../../pages/AdminConsole/ProfilesManagement/module/epic";
import recoveryPointEpic from "../../pages/AdminConsole/RecoveryPointManagement/module/epic";
import consoleAdminServiceRequestEpic from "../../pages/AdminConsole/ServiceRequestManagement/module/epic";
import sodManagementEpic from "../../pages/AdminConsole/SODManagement/module/epic";
import tablesConfigurationManagementEpic from "../../pages/AdminConsole/TablesConfigurationManagement/module/epics";
import consoleAdminTemporaryAbilitationsManagementEpic from "../../pages/AdminConsole/TemporaryAbilitationsManagement/module/epic";
import usersManagementEpic from "../../pages/AdminConsole/UsersManagement/module/epic";
import uigpManagementEpic from "../../pages/AdminConsole/UigpManagement/module/epic";
import csvManagementEpic from "../../pages/AdminConsole/CsvUploaderManagement/module/epic";
import consoleAdminTemplateSmsEpic from "../../pages/AdminConsole/TemplateSmsManagement/module/epic";
import consoleAdminTechnicalUserEpic from "../../pages/AdminConsole/TechnicalUsersManagement/module/epic";

import app from "./../../App/module/epics";

export default function createRootEpic() {
  const epics = [
    ...emergencyUserEpic,
    ...historyRequestEpics,
    ...abilitationEpics,
    ...approvalEpics,
    ...taskEpics,
    ...catalogEpics,
    ...delegationsEpics,
    ...usersRefereceEpic,
    ...userEntitlementsEpic,
    ...entitlementRefereceEpic,
    ...brManagementEpic,
    ...resetPasswordEpic,
    ...createCertificationEpic,
    ...changePasswordEpic,
    ...templateMailManagementEpic,
    ...manualReferenceEpic,
    ...workflowManagementEpic,
    ...passwordMgmtEpics,
    ...reportParameterSectionEpics,
    ...reportReportSectionEpics,
    ...consoleAdminServiceRequestEpic,
    ...CertificationReferenceEpic,
    ...consoleAdminCatalogMgmtEpic,
    ...ServiceRequestEpic,
    ...ProfileManagementEpic,
    ...LoginEpic,
    ...ReportRequestEpic,
    ...manualsManagementEpic,
    ...externalPortalEpics,
    ...welcomeEpics,
    ...app,
    ...tablesConfigurationManagementEpic,
    ...tablesConfigurationEpic,
    ...profilesMgmtEpic,
    ...externalPortalManagementEpic,
    ...sodManagementEpic,
    ...usersManagementEpic,
    ...consoleAdminApplicationEntitlementEpic,
    ...recoveryPointEpic,
    ...consoleAdminCertificationConfigurationsEpic,
    ...auditManagementEpic,
    ...notifyManagementEpic,
    ...temporaryAbilitationsEpics,
    ...consoleAdminTemporaryAbilitationsManagementEpic,
    ...consoleAdminBRManagementEpic,
    ...uigpManagementEpic,
    ...csvManagementEpic,
    ...consoleAdminTemplateSmsEpic,
    ...twoFactorAuthEpics,
    ...technicalUsersEpic,
    ...consoleAdminTechnicalUserEpic,
    /* ...sidebarEpics, */
    /* ...ErrorHandler, */
  ];

  const epic$ = new BehaviorSubject(combineEpics(...epics));

  const rootEpic = (action$, store) =>
    epic$.pipe(mergeMap((epic) => epic(action$, store)));

  return { rootEpic, epic$ };
}
